var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"mc-loading-overlay",style:(_vm.overlayStyle)},[(!_vm.getLoaderLogoPath)?_c('div',{staticClass:"mc-loading-spinner"}):_c('img',{staticClass:"mc-loading-logo mc-loading-logo--blinking",attrs:{"src":_vm.getLoaderLogoPath,"alt":_vm.alt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }